/**
 * Shared base classes and variant objects for input-like components.
 *
 * Each component keeps its own `cva()` call so focus-specific logic
 * (`:focus`, `data-[focused]`, `:focus-within`) stays inline and readable.
 */

// ── Base class groups ──────────────────────────────────────────────

export const inputBaseLayout = 'relative h-[44px] w-full px-4 py-[10px] leading-[24px]';

export const inputBaseTypography = 'rounded-lg typo-base text-space outline-none';

export const inputBaseTransition = 'transition-[background-color,box-shadow,border] duration-150';

export const inputBaseRing = 'ring-0 ring-indigo-crush';

// ── Shared variant objects ─────────────────────────────────────────

export const inputErrorVariant = {
  true: 'border-transparent bg-white ring-2 ring-errors',
  false: '',
} as const;

export const inputDisabledVariant = {
  true: 'bg-space-04 text-space opacity-40',
  false: '',
} as const;

export const inputWithLeftElementVariant = {
  true: 'pl-10',
  false: '',
} as const;

export const inputWithRightElementVariant = {
  true: 'pr-10',
  false: '',
} as const;
